import script from "./action-call-ai.vue?vue&type=script&setup=true&lang=js"
export * from "./action-call-ai.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__